import { ObjectValue, TDropDownList } from '@/types';

// New table types:start
export type TTableColumn = {
  name: string;
  field: string;
  useInFilter: boolean;
  filterValues?: TDropDownList;
  type?: keyof typeof EColumnType;
  filterTypeField?: keyof typeof EFilterTypeField;
  items?: TDropDownList;
  visible?: boolean;
  multiple?: boolean;
  role?: string;
  prefix?: keyof typeof EFilterValuePrefixes;
  useSort?: boolean;
  options?: ColumnOptions;
};

export type TTableColumns = Array<TTableColumn>;

export enum EColumnType {
  hidden = 'hidden',
  number = 'number',
  numberId = 'numberId',
  text = 'text',
  link = 'link',
  img = 'img',
  actions = 'actions',
  colors = 'colors',
  buttonIcon = 'buttonIcon',
  button = 'button',
  checkbox = 'checkbox',
}

export enum EFilterValuePrefixes {
  filter = 'filter',
  dimension = 'dimension',
  metric = 'metric',
}

export enum ETableUrlFilters {
  date = 'date',
  filter = 'filter',
  dimensions = 'dimensions',
  metrics = 'metrics',
  sort = 'sort',
  per__page = 'per__page',
  page = 'page',
}

export enum EFilterTypeField {
  input = 'input',
  list = 'list',
  select = 'select',
  datepicker = 'datepicker',
}

export type TSelectedFilterValue = {
  prefix?: keyof typeof EFilterValuePrefixes;
  filter?: string;
  name: string;
  field: string;
  label: string;
  value: string | number;
};

export type TSelectedFilterValues = Array<TSelectedFilterValue>;

export type TTableValuesPayload = {
  field: string;
  values: TDropDownList;
};

export type TTableVisiblePayload = {
  field: string;
  visible: boolean;
};
// New table types:end

// Old table types
export interface Column {
  name: string;
  field: string;
  type: string;
  useInFilter: boolean;
  filterValue?: string | number | Array<string | number> | null;
  relatedField?: string;
  visible?: boolean | null;
  items?: Array<ColumnItems>;
  filterTypeField?: string | null;
  options?: ColumnOptions;
  useSort?: boolean;
  role?: string;
  detailStatistics?: boolean;
  isSticky?: boolean;
  prefix?: string;
  postfix?: string;
  icon?: string;
  action?: any;
  value?: string;
  align?: string;
  multiple?: boolean;
}

export interface ColumnOptions {
  [name: string]: string;
}

export interface ActiveFilterFields {
  name: string;
  field: string;
  filterValue: string;
  filterValueLabel: string;
}

export interface ColumnItems {
  label: string;
  color?: string;
  htmlLabel?: string;
  value?: string | number;
}

export interface Row {
  [name: string]: number | string | Array<string | number> | ObjectValue;
}

export interface ExpandRow {
  [name: string]: Array<Row>;
}

export enum FilterTypeField {
  FILTER_TYPE_INPUT = 'input',
  FILTER_TYPE_DROPDOWN = 'dropdown',
  FILTER_TYPE_DATERANGE = 'daterange',
  FILTER_TYPE_DROPDOWN_FIELD = 'dropdownField',
}

export enum ColumnType {
  TYPE_HIDDEN = 'hidden',
  TYPE_NUMBER = 'number',
  TYPE_NUMBER_ID = 'numberId',
  TYPE_TEXT = 'text',
  TYPE_LINK = 'link',
  TYPE_IMG = 'img',
  TYPE_ACTIONS = 'actions',
  TYPE_COLORS = 'colors',
  TYPE_BUTTON_ICON = 'buttonIcon',
  TYPE_BUTTON = 'button',
  TYPE_CHECKBOX = 'checkbox',
}

export enum ColumnTypeColors {
  GREEN = 'green',
  RED = 'red',
}

export interface IUrlParams {
  [name: string]: string;
}

export enum ESortTypes {
  ASC = 'asc',
  DESC = 'desc',
  NONE = 'none',
}

export interface ISortTypes {
  none: string;
  asc: string;
  desc: string;
}
